import { Phone } from "lucide-react";
import React from "react";

interface PhoneComponentProps {
  country: string;
  phone: string;
  display?: string;
  className?: string;
}

const PhoneComponent: React.FC<PhoneComponentProps> = ({
  country,
  phone,
  display,
  className = "",
}) => {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className="text-sm">
        <p className="text-gray-400 text-xs mb-1">{country}</p>
        <a
          href={`tel:${phone}`}
          className="hover:text-white transition-colors duration-200"
        >
          {display ?? phone}
        </a>
      </div>
    </div>
  );
};

export default PhoneComponent;
